import type { FeedbackMessages } from './en';

const tr: FeedbackMessages = {
  qualified: {
    title: 'Bu araştırmayı tamamladığınız için teşekkür ederiz!',
    body1: 'Tarayıcı penceresini kapatabilirsiniz.',
    body2: 'Sizi yakında yeniden görmeyi umuyoruz.',
    refCode: 'Referans Kodu: {code}',
  },
  quotaFull: {
    title: 'Bu araştırma kapatılmıştır',
    body1: 'Araştırmamıza gösterdiğiniz ilgi için teşekkür ederiz.',
    body2: 'Ne yazık ki ihtiyacımız olan tüm yanıtları zaten aldık.',
    body3: 'Sizi gelecekteki araştırmalarımızdan birinde görmeyi umuyoruz!',
    refCode: 'Referans Kodu: {code}',
  },
  terminated: {
    title: 'Geri bildiminizi paylaştığınız için teşekkür ederiz!',
    body1:
      'Sizi gelecekteki araştırmalarımızda yakında görmeyi umuyoruz. O zamana kadar size iyi günler dileriz.',
    body2: 'Lütfen bu tarayıcı penceresini kapatın.',
    refCode: 'Referans Kodu: {code}',
  },
  mismatch: {
    title: 'İlginiz için teşekkür ederiz',
    body1: 'Ne yazık ki, bu özel araştırma için hedef grupta değilsiniz.',
    body2: 'Bu sayfayı kapatabilirsiniz.',
    code: 'Kod: {code}',
  },
  error: {
    title: 'Talebinizi karşılayamıyoruz',
    linkProblemDetailed:
      'Takip ettiğiniz bağlantıda bir sorun var. Lütfen adres satırındaki bağlantının size verilenle eşleştiğini kontrol edin ve tekrar deneyin.',
    linkProblemGeneric:
      'Takip ettiğiniz bağlantıda bir sorun var. Lütfen tekrar deneyin.',
    contactPerson:
      'Sorun devam ederse, lütfen bağlantıyı aldığınız kişiye bu sorunu bildirin.',
    errorCode: 'Hata Kodu: {code}',
  },
};

export default tr;
